import { css } from '@design.estate/dees-element';

/**
 * Shared dashboard-card anatomy for the serve.zone catalog.
 *
 * The frame itself belongs to dees-tile. These styles only define the
 * dashboard-specific header, content, footer, and empty-state hierarchy.
 */
export const dashboardCardStyles = css`
  :host {
    display: block;
    min-width: 0;
    height: 100%;
    color: var(--dees-color-text-primary);
  }

  dees-tile {
    height: 100%;
    min-width: 0;
    --dees-tile-surface: var(--dees-color-bg-primary);
  }

  .card-header {
    min-height: 52px;
    padding: 8px var(--dees-spacing-lg);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--dees-spacing-md);
  }

  .header-copy {
    min-width: 0;
  }

  .card-title {
    color: var(--dees-color-text-primary);
    font-size: var(--dees-font-control-size);
    font-weight: var(--dees-font-control-weight);
    line-height: 1.25;
    letter-spacing: -0.01em;
  }

  .card-subtitle {
    margin-top: 2px;
    color: var(--dees-color-text-muted);
    font-size: var(--dees-font-caption1-size);
    line-height: var(--dees-font-caption1-line);
  }

  .card-header > dees-icon {
    flex: 0 0 auto;
    color: var(--dees-color-text-muted);
  }

  .card-content {
    min-width: 0;
    padding: var(--dees-spacing-lg);
    box-sizing: border-box;
  }

  .card-footer {
    min-height: var(--dees-control-height-sm);
    padding: var(--dees-spacing-sm) var(--dees-spacing-lg);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: var(--dees-color-text-muted);
    font-size: var(--dees-font-caption1-size);
    line-height: var(--dees-font-caption1-line);
  }

  .empty-state {
    min-height: 72px;
    display: flex;
    align-items: center;
    color: var(--dees-color-text-muted);
    font-size: var(--dees-font-callout-size);
  }
`;
